import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Button } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { RequiredLabelDirective } from '../../../../../../../shared/directive/required-label.directive';
import { AdminPanelUserActionDialogData } from '../../../../../../../shared/models/admin-panel-user-action-dialog-data';

@Component({
  selector: 'app-admin-panel-user-action-dialog',
  imports: [Button, ReactiveFormsModule, RequiredLabelDirective],
  templateUrl: './admin-panel-user-action-dialog.component.html',
  styleUrl: './admin-panel-user-action-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelUserActionDialogComponent {
  readonly #config = inject(DynamicDialogConfig);
  protected readonly dialogRef = inject(DynamicDialogRef);

  protected readonly data = this.#config.data as AdminPanelUserActionDialogData;
  protected readonly form = new FormGroup({
    justification: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });
  protected readonly justificationValue = toSignal(
    this.form.controls.justification.valueChanges,
    { initialValue: this.form.controls.justification.getRawValue() },
  );
  protected readonly canConfirm = computed(
    () => this.justificationValue().trim().length > 0,
  );

  protected confirm(): void {
    const justification = this.form.controls.justification.getRawValue().trim();

    if (!justification) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(justification);
  }
}
